module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ct-da"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" “The Wondrous Transformation of Thought into Sound”: Some Preliminary Reflections on Musical Meaning in Brahms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#chap01author"
    }
  }, [_c('em', [_vm._v("Heather Platt and Peter H. Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" The Learned Self: Artifice in Brahms’s Late Intermezzi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#chap02author"
    }
  }, [_c('em', [_vm._v("Steven Rings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" “Alte Liebe” and the Birds of Spring: Text, Music, and Image in Max Klinger’s "), _c('em', [_vm._v("Brahms Fantasy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap03author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Yonatan Malin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Brahms’s "), _c('em', [_vm._v("Mädchenlieder")]), _vm._v(" and Their Cultural Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#chap04author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Heather Platt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Ancient Tragedy and Anachronism: Form as Expression in Brahms’s "), _c('em', [_vm._v("Gesang der Parzen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#chap05author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Margaret Notley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Sequence as Expressive Culmination in the Chamber Music of Brahms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#chap06author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ryan McClelland")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7.")]), _vm._v(" “Phantasia subitanea”: Temporal Caprice in Brahms’s op. 116, nos. 1 and 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#chap07author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Frank Samarotto")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8.")]), _vm._v(" Monumentality and Formal Processes in the First Movement of Brahms’s Piano Concerto No. 1 in D Minor, op. 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#chap08author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("James Hepokoski")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9.")]), _vm._v(" The drama of tonal Pairing in Chamber music of Schumann and Brahms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#chap09author",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Peter H. Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("List of Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index of Brahms’s Compositions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/generalindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("General Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0